import { render, staticRenderFns } from "./view-setting.vue?vue&type=template&id=41c9c4ae&scoped=true&"
import script from "./view-setting.vue?vue&type=script&lang=js&"
export * from "./view-setting.vue?vue&type=script&lang=js&"
import style0 from "./view-setting.vue?vue&type=style&index=0&id=41c9c4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9c4ae",
  null
  
)

export default component.exports